// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Help: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M6.5 7c-.372 0-.625.253-.625.625a.625.625 0 001.25 0A.61.61 0 006.5 7zm.519-4.5H5.881c-.762 0-1.38.62-1.38 1.381a.5.5 0 101 0c0-.21.171-.381.38-.381h1.137a.482.482 0 01.21.915l-.959.498c-.166.059-.269.256-.269.443V6a.5.5 0 101 0v-.34l.68-.354c.48-.25.82-.76.82-1.325C8.5 3.166 7.835 2.5 7.02 2.5zM13 5.5C13 2.462 10.09 0 6.5 0S0 2.462 0 5.5c0 1.296.534 2.486 1.42 3.425a8.211 8.211 0 01-1.217 1.824A.74.74 0 00.74 12c1.693 0 3.055-.648 3.934-1.224.58.143 1.192.224 1.826.224 3.59 0 6.5-2.462 6.5-5.5zM6.5 10c-.53 0-1.064-.066-1.586-.195L4.491 9.7l-.366.24c-.638.419-1.612.907-2.808 1.03a8.923 8.923 0 001.008-1.618l.289-.616-.466-.495C1.398 7.444 1 6.497 1 5.5 1 3.019 3.44 1 6.5 1S12 3.019 12 5.5 9.531 10 6.5 10zm12.45 3.606A5.155 5.155 0 0020 10.5C20 7.463 17.313 5 14 5l-.029.001c.014.165.03.33.03.499 0 .17-.015.336-.03.503L14 6c2.756 0 5 2.019 5 4.5 0 .897-.295 1.764-.852 2.508l-.41.546.36.58c.205.331.412.617.582.835a6.013 6.013 0 01-1.697-.44l-.397-.166-.393.174A5.41 5.41 0 0114 15c-2.345 0-4.303-1.466-4.84-3.428-.316.104-.641.191-.975.258C8.835 14.222 11.16 16 14 16c.932 0 1.81-.2 2.598-.548A6.843 6.843 0 0019.26 16a.74.74 0 00.536-1.25c-.005-.006-.433-.475-.846-1.144zm-6.803-3.043a.5.5 0 000 .706l1.166 1.168a.5.5 0 00.706 0l2.583-2.584a.5.5 0 10-.706-.706l-2.23 2.23-.814-.813a.5.5 0 00-.705-.002z" />
        </svg>
    );
};

export default React.memo(Help);
